'use client'

import Image from 'next/image'
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'

interface HomeTestimonialProps {
	data?: {
		heading?: {
			title?: string
		}
		text?: {
			text?: string
		}
		image?: {
			alt: string
			image_file: {
				image: {
					id: string
					filename_download: string
				}
			}
		}
	}
}

export const fields = [
	'heading.title',
	'text.text',
	'image.alt',
	'image.image_file.image.id',
	'image.image_file.image.filename_download',
] as const

export default function HomeTestimonial({ data }: HomeTestimonialProps) {
	return (
		<section className='HomeTestimonial relative md:bg-[#606769] w-full overflow-hidden'>
			<div className='flex flex-col md:flex-row items-start justify-end relative'>
				{/* Left column with image */}
				<div className='md:absolute left-0 h-full w-full md:w-[60%] overflow-hidden'>
					<div className='relative w-full h-[300px] md:h-full'>
						<Image
							src={getReadableImageUrl(
								data?.image?.image_file?.image?.id || '',
								data?.image?.image_file?.image?.filename_download || ''
							)}
							alt={data?.image?.alt || ''}
							className='object-cover object-left w-full h-full'
							fill
							priority
							sizes='(max-width: 768px) 100vw, 60vw'
							quality={90}
						/>
					</div>
				</div>

				{/* Right column with content */}
				<div className='relative w-[100%] md:w-[50%] bg-neutral-50 flex flex-col gap-12 md:my-28 pt-16 p-8 2xl:p-20 md:p-14 xl:pr-32'>
					{/* H Logo - positioned as overlay between sections */}
					<div className='absolute top-[-30px] md:top-[-12%] top-0 lg:right-auto lg:left-[-70px] left-35 md:transform md:-translate-y-1/2 md:-translate-x-1/2 lg:translate-x-0 md:-translate-y-1/2 md:-translate-x-1/2 --tw-translate-x-0 lg:translate-y-0 z-10'>
						<Image
							src='/images/quotes.svg'
							alt='Quote icon'
							width={112}
							height={112}
							className='w-16 md:w-28 h-16 md:h-28'
							priority
						/>
					</div>

					{/* Cincinnati Office */}
					<div className='grid gap-6'>
						<div
							className='text-gray-slate [&>p]:text-xl md:[&>p]:text-2xl 2xl:[&>p]:text-3xl'
							dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
						/>

						{/* Author */}
						<p className='text-gray-green text-xl lg:text-2xl uppercase text-right'>
							{data?.heading?.title || ''}
						</p>
					</div>
				</div>
			</div>
		</section>
	)
}
